import React from "react";

const holder = {
  unfocus(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter('focused', false);
      document.removeEventListener("mousedown", holder.unfocus)
    }
  }
};


export default {
  'InputWithTextButton.Wrapper': async ({ containerRef, disabled, inputRef, focused }, _, internalStateSetter) => {
    if (disabled) return;
    if (focused) return;
    await internalStateSetter('focused', true);

    let newContainerRef = containerRef;
    let newInputRef = inputRef;

    if (!containerRef || !inputRef) {
      newContainerRef = React.createRef(null);
      newInputRef = React.createRef(null);
      await internalStateSetter({ containerRef: newContainerRef, inputRef: newInputRef });
    }

    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = newContainerRef;
    newInputRef?.current?.children?.[0]?.children?.[0]?.focus?.()
    document.addEventListener("mousedown", holder.unfocus);
  },
  'InputWithTextButton.Wrapper.InputWrapper.Input': ({ value, maxLength }, outlet, internalStateSetter) => {
    if (maxLength && (value.length > maxLength)) {
      return;
    }
    outlet({ action: "focused" })
    internalStateSetter({ value });
  },
  'InputWithTextButton.Wrapper.InputWrapper.Input(Keydown)': async ({ value, key, maxLength, containerRef, disabled, inputRef, focused }, outlet, internalStateSetter) => {
    if (maxLength && (value.length > maxLength)) {
      return;
    }
    if (key === 'Enter') {
      if (!value) return;
      outlet({ value });
      await internalStateSetter({ value: '', focused: true });

      let newContainerRef = containerRef;
      let newInputRef = inputRef;
      if (!containerRef || !inputRef) {
        newContainerRef = React.createRef(null);
        newInputRef = React.createRef(null);
        await internalStateSetter({ containerRef: newContainerRef, inputRef: newInputRef });
      }
  
      holder.internalStateSetter = internalStateSetter;
      holder.containerRef = newContainerRef;
      newInputRef?.current?.children?.[0]?.children?.[0]?.focus?.()
      document.addEventListener("mousedown", holder.unfocus);
    }
  },
  'InputWithTextButton.Wrapper.SaveButton': ({ value }, outlet, internalStateSetter) => {
    if (!value) return;
    outlet({ value });
    internalStateSetter({ value: '' });
    internalStateSetter({ focused: false });
  }
}